'use strict';

import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Status, fetchResults } from './cfs-search-slice';

import advert from '../../../adverts/advert';
import clickableContainer from '../../../ui/clickable-container';
import analytics from '../../../utils/analytics';
import history from '../../../utils/history';
import parkersCompareLinks from '../../../utils/parkers-compare-links';
import callDealer from '../../../components/forsale/call-dealer';
import saveForLater from '../../../components/forsale/save-for-later';
import permutive from '../../../utils/permutive';

const ErrorExcerpt = () => {
	return (
		<div className="search-results__no-results">
			<span className="fi-icon fi-icon--xxlarge fi-info"></span>
			<span>An error occured retrieving your results, please refresh or try again</span>
		</div>
	);
};

export const Results = () => {
	const [isFirstLoad, setIsFirstLoad] = useState(true);
	const dispatch = useDispatch();

	const doUpdate = useSelector((state) => state.cfsSearch.updateResults);

	const resultsStatus = useSelector((state) => state.cfsSearch.resultsStatus);
	const results = useSelector((state) => state.cfsSearch.results);
	const encodedQueryState = useSelector((state) => state.cfsSearch.filterState.encodedQueryState);
	const resultsUrl = useSelector((state) => state.cfsSearch.filterState.resultsUrl);
	const searchType = useSelector((state) => state.cfsSearch.filterState.searchType);

	useEffect(() => {
		if (doUpdate) {
			dispatch(fetchResults(encodedQueryState));
		}
	}, [doUpdate, encodedQueryState, dispatch]);

	useEffect(() => {
		if (resultsStatus === Status.Loading && resultsUrl) {
			const title = `${searchType} cars for sale`;
			history.setUrl(resultsUrl, false, title, { facetedSearch: true });
			$('.page-heading h1').html(title);

			analytics.trackPageview(resultsUrl);
			analytics.trackIpsosIrisPageView();
		}
	}, [resultsStatus, resultsUrl]);

	useEffect(() => {
		if (resultsStatus === Status.Succeeded) {
			callDealer.init();
			clickableContainer.init();
			parkersCompareLinks.init();
			saveForLater.init('Click Search Results');

			$('.search-proposition-text').remove();

			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});

			advert.updateTargeting();
			permutive.updateTargeting();
			advert.loadResultAds();
		}
	}, [resultsStatus]);

	if (isFirstLoad) {
		if (resultsStatus === Status.Uninitialised) {
			return null;
		} else if (resultsStatus === Status.Loading) {
			// On first load, it still shows server-rendered results, so need to style them directly instead of relying on render
			$.findByBem('search-results').addBemClass('search-results', null, 'loading');
			return null;
		} else {
			$('.search-results').remove();
			setIsFirstLoad(false);
		}
	}

	const className = 'search-results';

	if (resultsStatus === Status.Failed) {
		return (
			<section className={className}>
				<ErrorExcerpt />
			</section>
		);
	}

	const html = results;

	return (
		<section className={className} dangerouslySetInnerHTML={{ __html: html }} />
	);
}